import React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { HiOutlinePhone, } from 'react-icons/hi';


import {
    FooterContainer,
    FooterWrap,

    FooterLogo,
    Logo,
    FooterCallContainer,

    SocialMedia,
    SocialMediaWrap,
    WebsiteRights,
} from './FooterElements'

import logo from '../../img/logo-md.svg';
import theme from '../../const/theme';


const Footer = () => {
    const toggleHome = () => {
        scroll.scrollToTop()
    }

    return (
        <>
            <FooterContainer id="contact">
                <FooterWrap>

                    <SocialMedia>
                        <SocialMediaWrap>
                            <FooterLogo to="home"

                                smooth={true}
                                duration={500}
                                spy={true}
                                exact="true"
                                offset={-100}>
                                <Logo src={logo} />

                            </FooterLogo>
                            <FooterCallContainer>


                            </FooterCallContainer>
                        </SocialMediaWrap>
                        <WebsiteRights> &copy; {new Date().getFullYear()} All rights reserved.</WebsiteRights>
                    </SocialMedia>
                </FooterWrap>
            </FooterContainer>
        </>
    )
}

export default Footer

const styles = {
    arrowLeft: {
        width: 0,
        height: 0,
        backgroundColor: 'transparent',
        borderStyle: 'solid',
        borderTopWidth: 7,
        borderRightWidth: 7,
        borderBottomWidth: 7,
        borderLeftWidth: 0,
        borderTopColor: 'transparent',
        borderRightColor: theme.COLORS.PRIMARY,
        borderBottomColor: 'transparent',
        borderLeftColor: 'transparent',
        marginLeft: 20,
    },
}